const WEARING_STATUS = {
  "-1": "Unknown",
  0: "Off finger",
  1: "On finger",
  2: "Charging",
};

export const getWearingStatus = (status) => WEARING_STATUS[status] || "Unknown";

const CONNECTION_STATUS = {
  0: {
    device_connected: false,
  },
  1: {
    device_connected: true,
  },
};

export const getConnectionStatus = (status) => CONNECTION_STATUS[status] || {};
